import find from 'lodash/find';
import { RegvarModel } from './index';
export class RegvarListModel extends RegvarModel {
    getValue() {
        const value = this.value;
        if (!value) {
            return null;
        }
        const selectedItem = find(this.$rcc.regvarMetadata.listValues, (item)=>item.id === value);
        if (!selectedItem) {
            throw new Error(`No list item with id ${value} was found.`);
        }
        return selectedItem;
    }
    setValue(value, options) {
        const $rcc = this.$rcc;
        const regvarMetadata = $rcc.regvarMetadata;
        let newValue = null;
        if (!value) {
            newValue = null;
        } else {
            switch(typeof value){
                case 'function':
                    {
                        const listItem = find(regvarMetadata.listValues, value);
                        if (!listItem) {
                            throw new Error(`${$rcc.shortname}: list item not found.`);
                        }
                        newValue = listItem.id;
                        break;
                    }
                case 'object':
                    if (!Object.prototype.hasOwnProperty.call(value, 'id')) {
                        throw new Error(`${$rcc.shortname}: missing id property.`);
                    }
                    newValue = value.id;
                    break;
                case 'string':
                    newValue = parseInt(value, 10) || value;
                    break;
                case 'number':
                    newValue = value;
            }
        }
        return super.setValue(newValue, options);
    }
    isOneOf(values) {
        return values.some((value)=>value === this.getValue()?.value);
    }
    getListItemByValue(value) {
        const listItems = this.$rcc.regvarMetadata.listValues;
        return listItems.find((listItem)=>listItem.value === value);
    }
    getListItemById(value) {
        const listItems = this.$rcc.regvarMetadata.listValues;
        return listItems.find((listItem)=>listItem.id === value);
    }
    getListItems(filterFn, options) {
        const listItems = this.$rcc.regvarMetadata.listValues;
        if (filterFn && typeof filterFn === 'function') {
            if (options?.keepChosen) {
                return listItems.filter((lv)=>lv.id === this.getValue()?.id || filterFn(lv));
            }
            return listItems.filter(filterFn);
        }
        return listItems;
    }
}
